import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import ConfirmComp from "src/components/shared/ConfirmComp";
import DeleteIcon from "src/components/shared/icon/DeleteIcon";
import UpdateIcon from "src/components/shared/icon/UpdateIcon";
import ViewIcon from "src/components/shared/icon/ViewIcon";
import useAppGlobal from "src/context/useAppGlobal";
import useCustomerDelete from "src/hooks/user/customer/useCustomerDelete";
import { v4 as uuid } from "uuid";
import CustomerViewDialog from "../CustomerViewDialog";
import CustomerCreateDialog from "../CustomerCreateDialog";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
export default function useCustomerAction() {
  const permissionCheck = useRoleCheck();
  const { handleOpenDialog, closeDialog } = useAppGlobal();
  const [customerId, setCustomerId] = useState();
  const { trigger: removeCustomer } = useCustomerDelete(customerId);

  const handleUpdate = (item) => {
    handleOpenDialog({
      title: "Cập nhật thông tin Khách Hàng",
      content: (
        <CustomerCreateDialog
          key={uuid()}
          item={item}
        />
      ),
      size: "md",
    });
  };
  const handleCustomerRemove = async () => {
    const res = await removeCustomer();
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message ?? "Có lỗi xảy ra", { variant: "error" });
    }
  };

  const handleView = (item) => {
    handleOpenDialog({
      title: "Chi tiết khách hàng",
      content: <CustomerViewDialog item={item} />,
      size: "sm",
    });
  };

  const action = [
    {
      id: uuid(),
      icon: <ViewIcon />,
      onClick: (item) => handleView(item),
      type: "icon",
      disabled: !permissionCheck([PERMISSIONS.VIEW_CUSTOMER]),
    },
    {
      id: uuid(),
      icon: <UpdateIcon />,
      onClick: (item) => handleUpdate(item),
      type: "icon",
      disabled: !permissionCheck([PERMISSIONS.UPDATE_CUSTOMER]),
    },
    {
      id: uuid(),
      icon: <DeleteIcon />,
      onClick: (item) => {
        setCustomerId(item?._id);
        handleOpenDialog({
          content: (
            <ConfirmComp
              name={item?.fullName}
              onConfirm={() => handleCustomerRemove(item?._id)}
            />
          ),
          size: "md",
        });
      },
      type: "icon",
      disabled: !permissionCheck([PERMISSIONS.DELETE_CUSTOMER]),
    },
  ];
  return action;
}
